import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../../../DesignSystem/Buttons/SecondaryButton";
import { PostCard, Row } from "../HelperFunctions/HelperFunctions";
import { subscribeIODetails } from "./ioDetailsService";

const IODetailsTab = ({ adviserKey, adviserEmail, details, canEdit }) => {
  const navigate = useNavigate();
  const [ioDetails, setIODetails] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
    return subscribeIODetails(adviserEmail, setIODetails, () =>
      setError("IO details could not be loaded."),
    );
  }, [adviserEmail]);

  const handleEdit = () => {
    const key = adviserKey || adviserEmail;
    if (!key) return;

    navigate(`/advisers/${encodeURIComponent(key)}/io-details/edit`, {
      state: {
        adviserEmail,
        details,
        ioDetails,
        returnTo: `/advisers/${encodeURIComponent(key)}?tab=ioDetails`,
      },
    });
  };

  const displayIds = (value) =>
    (Array.isArray(value) ? value : [value])
      .filter((entry) => entry !== "" && entry != null)
      .join(", ");

  return (
    <div className="smFeed">
      {canEdit ? (
        <div className="smEditActions">
          <div>
            <div className="FP_Body_Semibold">IO Details</div>
            <p className="Content-Small muted">
              Adviser details used by IO.
            </p>
          </div>
          <div className="smEditActionsRight">
            <SecondaryButton label="Edit Details" onClick={handleEdit} />
          </div>
        </div>
      ) : null}

      {error ? (
        <div className="Content-Small adviserLicenseError">{error}</div>
      ) : null}

      <PostCard title="IO Details">
        <Row label="CRM Contact ID" value={displayIds(ioDetails.ioAdviserId)} />
        {canEdit ? <Row label="ID" value={displayIds(ioDetails.id)} /> : null}
        {canEdit ? <Row label="Group ID" value={displayIds(ioDetails.groupId)} /> : null}
        {canEdit ? <Row label="User ID" value={displayIds(ioDetails.userId)} /> : null}
      </PostCard>
    </div>
  );
};

export default IODetailsTab;
